// src/utils/testTypeAPI.js
//import axios from "axios";

//const API_BASE = "https://bharatparikhsa-backend.onrender.com/api/test-types";
import API from "../api";

export const fetchTestsByType = async (type) => {
  try {
    // ✅ axios instance automatically uses:
    // http://localhost:5000/api
    const res = await API.get(`/test-types/type/${type}`);
    return res.data;
  } catch (err) {
    console.error(`❌ Error fetching ${type} tests:`, err);
    throw err;
  }
};

